export default __webpack_public_path__ + "static/media/assign-template-white.109a69cb.svg";